import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux";
import { Toast, ToastBody } from "reactstrap"
import { resetLoginErrorMsg } from "../../../store/actions";
import withRouter from "../../Common/withRouter";
import PropTypes from "prop-types"


const Toaster = props => {
  const [isToast, setIsToast] = useState(true)
  const dispatch = useDispatch();
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsToast(false);
      props.dispatchAction && dispatch(props.dispatchAction())

    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  }, [])
  return (
    <div
      style={{ zIndex: "11" }}
      className="position-fixed end-0 bottom-0 px-2 w-25 mt-5"
    >
      <Toast
        isOpen={isToast}
        id="borderedToast1"
        className="toast overflow-hidden w-100 mb-5"
      >
        <div
          className={`align-items-center text-white  border-0 ${props.isFailed ? 'bg-danger' : 'bg-success'}`}>
          <div className="d-flex">
            <ToastBody className="text-center">{props.message}.</ToastBody>
          </div>
        </div>
      </Toast>
    </div>

  )
}

export default withRouter(Toaster)

